import { url } from "../Functionalities/Config";

// Base getRestaurantsUrl for backward compatibility (using full url if needed)
export const getRestaurantsUrl = `${url}/branch/rest-listings/?`;

// Branch / Restaurant Endpoints
export const branchDetailsUrl = "/branch/details/";
export const branchAdminAddUrl = "/branch/adminadd/";
export const branchMostRatedUrl = "/branch/mostrated/";
export const branchAddUserUrl = "/branch/adduser/";
export const branchManagersUrl = "/branch/branchmanagers/";

// Franchise Endpoints
export const franchiseDetailsUrl = "/franchise/details/";

// Configurations Endpoints
export const configurationsUrl = "/configurations/";
export const configurationsParamUrl = "/configurations/param/";
export const configurationsFranchiseUrl = "/configurations/franchise/";
export const configurationsAdminUrl = "/configurations/admin/";

// Admindashboard Endpoints
export const adminDashboardUrl = "/admindashboard/";
export const adminDashboardOrderSummaryUrl = "/admindashboard/ordersummary/";

// Insights Endpoint
export const insightsUrl = "/insights/";

// Restaurant payouts
export const partnerAdminPayoutsUrl = "/partner/admin/payouts/";
export const partnerPayoutOptionsUrl = "/partner/payouts/options/";
export const partnerAdminResponsivenessUrl = "/partner/admin/responsiveness/";

// Accounts Endpoints
export const accountsUrl = "/accounts/";
export const accountsAccountsUrl = "/accounts/accounts/";
export const accountsAllAccountsUrl = "/accounts/allaccounts/";
export const accountsBranchBalanceUrl = "/accounts/branchbalance/";
export const accountsTransactionsUrl = "/accounts/accounttransactions/";

// Items / Menu Endpoints
export const itemsDetailsUrl = "/items/details/";
export const itemsSloatUrl = "/items/sloat/";
export const itemsVarientUrl = "/items/varient/";
export const itemsItemVarientsUrl = "/items/itemvarients/";
export const itemsInnerCategoryUrl = "/items/innercategory/";

// Order Endpoints
export const orderDeliveryBoyUrl = "/order/deliveryboy/";
export const orderDetailsUrl = "/order/details/";
export const orderStatusUrl = "/order/status/";
export const orderItemsAdminUrl = "/order/items/admin/";
export const orderEditsUrl = "/order/edits/";

// User & Profile Endpoints
export const userUserCategoryUrl = "/user/usercategory/";
export const userProfileUrl = "/user/profile/";

// Delivery Endpoints
export const deliveryDbDetailsUrl = "/delivery/dbdetails/";

// Review Endpoints
export const reviewReviewUrl = "/review/review/";
export const reviewDeliveryBoyUrl = "/review/reviewdeliveryboy/";

// Wallet Endpoints
export const walletWalletUrl = "/wallet/wallet/";

// Notifications Endpoints
export const notificationsUrl = "/notifications/";

// PromoCodes Endpoints
export const promocodesDetailsUrl = "/promocodes/details/";

// Items Category / Offer Endpoints
export const itemsCategoryUrl = "/items/category/";
export const itemsOfferUrl = "/items/offer/";

// Notifications Admin Token Endpoint
export const notificationsAdminTokenUrl = "/notifications/admintoken/";

export const homeBannersAdminUrl = "/banners/admin/";
export const homeBannerSectionsUrl = "/banners/admin/sections/";
export const homeBannerItemsUrl = "/banners/admin/banners/";
export const homeBannerReorderUrl = "/banners/admin/banners/reorder/";
export const surplusBannersUrl = "/banners/surplus/";
export const homeFeedUrl = "/items/home/";
